<template>
    <ModalFormCard class="modal-default" :action='"/page-template" + (editingModel != null ? "/"+editingModel.id : "")'>
        <template #title>{{ editingModel == null ? 'Save' : 'Edit' }} view</template>

        <template #default="{ saving, errors }">
            <Input label='View name' placeholder='Enter view name' 
                v-model:value='value.name' name='name'
            />

            <input name='json' :value='value.json' type='hidden' />
            <input name='page_id' :value='value.page_id' type='hidden' />

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Save view
				</ButtonSaving>

                <button class="button-purple col-span-2 lg:col-span-1 h-12 default" v-if='editingModel != null' @click="back">Back</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                value: {
                    name: '',
                    json: null,
                    page_id: null
                }
            }
        },

        created() {
            if (this.editingModel != null) {
                this.value.name = this.editingModel.name;
                this.value.json = this.editingModel.settings;
                this.value.page_id = this.editingModel.page_id;
            } else {
                this.value.json = this.options.json;
                this.value.page_id = this.options.page_id;
            }
        },

        methods: {
            back() {
                this.$pop("TableManageViews", {
                    options: {
                        templates: this.options.templates
                    }
                });
            }
        },  

        computed: {
        },

        components: {
        }
    }
</script>